import { useState, useEffect, useCallback } from "react";
import MDEditor from "@uiw/react-md-editor";
import { Label } from "@/components/ui/label";

interface ShortDescriptionEditorProps {
  content: string;
  language: string;
  onChange: (content: string) => void;
}

const ShortDescriptionEditor = ({
  content,
  language,
  onChange,
}: ShortDescriptionEditorProps) => {
  const [value, setValue] = useState<string | undefined>("");
  const [theme, setTheme] = useState<"light" | "dark">(
    document.documentElement.classList.contains("dark") ? "dark" : "light"
  );

  // Update content when language changes
  useEffect(() => {
    setValue(content || "");
  }, [content, language]);

  // Listen for theme changes
  useEffect(() => {
    const observer = new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        if (
          mutation.attributeName === "class" &&
          mutation.target === document.documentElement
        ) {
          setTheme(
            document.documentElement.classList.contains("dark")
              ? "dark"
              : "light"
          );
        }
      });
    });

    observer.observe(document.documentElement, { attributes: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  const handleChange = (newContent: string | undefined) => {
    setValue(newContent || "");
    onChange(newContent || "");
  };

  return (
    <div className="space-y-4" data-color-mode={theme}>
      <Label htmlFor="short-description">Short Description</Label>
      <MDEditor
        value={value}
        onChange={handleChange}
        height={250}
        preview="edit"
        className={theme === "dark" ? "wmde-markdown-dark" : ""}
      />
      <div className="text-xs text-muted-foreground pt-2">
        <p>
          Use Markdown to format text. Supports headings, bold, italics, links,
          lists, and more.
        </p>
      </div>
    </div>
  );
};

export default ShortDescriptionEditor;
